import useSWR from 'swr'

import { CostCenter, costCenterSchema } from '../types'
import { validateResponse } from '../utils'
import { useApi } from '../store/mainContext'

export default function useCostCenter(costCenterId: CostCenter['_id']) {
  const api = useApi()
  return useSWR<CostCenter, Error>(['cost-center', costCenterId], () =>
    api
      .get(`cost-centers/${costCenterId}`)
      .then(validateResponse(costCenterSchema)),
  )
}
